// forms/wasteDisposalForm/state.js

// Waste Disosal State
export const wasteDisposalInitialState = {
  activeWasteDisposalTab: "All",
};
